export const findNodeByPath = (root, pathArr) => {
  if (!root || !Array.isArray(pathArr) || pathArr.length === 0) return null;

  // path looks like: ["Home", "Videos", "SomeChild"]
  let node = root;
  // start from index 1 because root is "Home"
  for (let i = 1; i < pathArr.length; i++) {
    const nextName = pathArr[i];
    const next = (node?.children || []).find((c) => c.name === nextName);
    if (!next) break; // if path mismatch, stop at last valid node
    node = next;
  }
  return node;
};